export const coreValues = [
  {
    title: "Ownership",
    description:
      "We own every decision we make. This means holding ourselves accountable for not only the short-term results, but also the long-term impact on growth, sustainability, and community."
  },
  {
    title: "Excellence",
    description:
      "We aim for excellence in all aspects of our work. Whether we’re analyzing a cash flow, advising a nonprofit or executing a technical development plan, we set the highest personal and professional standards."
  },
  {
    title: "Creativity",
    description:
      "We push to break through convention. Creativity is founded on extreme effort, persistence and forward-thinking. This process allows us to unlock unseen potential."
  },
  {
    title: "Trust",
    description:
      "We build our business on relationships. We safeguard our trusted network of investors, clients, partners, consultants and employees to secure the most attractive opportunities and deliver the best results."
  }
];
export const ourCapabilities = [
  {
    title: "Acquisition",
    description: `Thelius seeks to acquire commercial real estate
      assets in the Northeast United States to
      generate exceptional risk-adjusted returns for
      our investors. We have secured significant
      capital through qualified institutional and
      private wealth investors as well as close
      lending relationships. Our executive team has
      acquired over $7BN of real estate assets
      globally.`
  },
  {
    title: "Development & Construction",
    description: `Thelius has in-house capabilities to plan and
      manage all phases of complex repositioning or
      development projects. This enables us to execute
      challenging, multi-faceted projects with
      exceptional efficiency. Our executive team has
      completed over 10MM SF of ground-up projects and
      over 3MM SF of commercial building
      repositionings globally.`
  },
  {
    title: "Asset Management",
    description: `Thelius manages all investments in-house. We
      implement the best industry practices in all
      phases of asset management and deliver
      impeccable oversight and reporting to our
      investors. Our executive team managed over 8MM
      SF of commercial assets globally.`
  },
  {
    title: "Advisory",
    description: `Thelius provides strategic planning and
      capital-raising advisory services to clients
      with an aim of potentially serving as an
      investment partner. We provide a strategic
      business plan, which guides our clients to
      understand their options to maximize potential
      value of their assets. Our executive team has
      completed over $3BN of real estate advisory
      transactions globally.`
  },
  {
    title: "Nonprofit",
    description: `Thelius works closely with nonprofits to
      maximize their real estate value as a means to
      secure resources to sustain their missions. We
      have a keen insight into their unique process
      and a strong track record of delivering
      substantial results. Our executive team is proud
      to have served over 20 religious and academic
      institutions in the New York area.`
  },
  {
    title: "Cross Border",
    description: `Thelius has long-standing relationships with
      investors, clients and partners in Asia Pacific.
      This gives us access to the fast-growing source
      of capital seeking for exposure in US real
      estate as well as alternative investing
      opportunities for our US investors. Our
      executive team has significant experience in
      investing and advisory in the region during the
      past 20 years.`
  }
];
export const team = [
  {
    name: "John LaValley",
    title: "Managing Partner",
    description: `John is a Founder and Managing
      Partner of Thelius Capital Partners
      LLC. Prior to founding Thelius, he
      founded East Gate, an investment
      advisor that specialized in
      repositioning commercial real estate
      in Manhattan. East Gate completed 3
      marquee investments, including the
      repositioning of a 1 million SF
      hotel and its operating company.
      Before founding East Gate, he served
      as a Portfolio Head and Vice
      President of Investments at Onyx
      Equities, a fully-integrated private
      equity investment company that
      directly owns over $2BN of real
      estate. While at Onyx, he was
      selected as Tomorrow’s Leader in
      Real Estate by Globest (2013), won
      Deal of the Year by NAIOP (2014),
      and led Onyx’s opportunistic
      redevelopment strategy in New York
      City and Jersey City. Prior to Onyx,
      John worked as an acquisitions
      analyst at Centersquare, a private
      equity firm with an $8BN AUM. John
      graduated from the University of
      Pennsylvania with a BA in Economics.
      John spends his free time competing
      in regional rock climbing
      competitions.`
  },
  {
    name: "Jin Eu",
    title: "Managing Partner",
    description: `Jin is a Founder and Managing
      Partner of Thelius Capital Partners
      LLC. Previously, Jin was the Chief
      Executive Officer of Morgan Stanley
      Capital Korea, Ltd. and the Korea
      Country Head for Morgan Stanley Real
      Estate (MSRE), responsible for
      acquisition, asset management and
      advisory. At its peak, MSRE had
      $100BN under management in 33
      countries. Jin was one of the first
      executive members of Asia Pacific
      who drove the growth of MSRE as a
      premier real estate franchise in the
      region. During his 15 years with
      Morgan Stanley, Jin was involved in
      $6BN of principal investments and
      $10BN of advisory transactions in
      US, Korea, Hong Kong, China,
      Singapore and Australia. Prior to
      Morgan Stanley, Jin worked as an
      investment banker at Lehman Brothers
      in New York. Jin graduated from
      Vassar College with a Bachelor’s
      degree in History. In his rare time
      off, Jin plays jazz piano and raises
      a 2-year old daughter.`
  },
  {
    name: "Joerg Joergensen",
    title: "Chief Financial Officer",
    description: `Joerg is a senior finance and
      operating executive with over 15
      years of experience in financial
      management, strategy development,
      and driving operational
      improvements. His business
      experience includes managing across
      functions and cultures and spans
      both Europe and North America. He is
      currently operating as a CFO in the
      advisory practice of Escalon, a
      trusted on-demand accounting and
      finance solution for growing
      businesses.`
  },
  {
    name: "Joseph Denn",
    title: "Executive Director, Development",
    description: `Joe is an Executive Director of
      Development. He is primarily
      responsible for leading Thelius’
      development division, which includes
      sourcing new opportunities,
      entitlement and approvals, design,
      engineering, construction
      management, and developing market
      rate and affordable housing. Prior
      to joining Thelius, Joe founded and
      led several successful development
      companies over the last three
      decades, including Cobble Creek
      Builders, Foresite Development Corp,
      Greystone Construction, Spectrum
      Skanska, and Spectrum Group. These
      companies completed over $500MM
      worth of commercial development,
      constructed and sold 1,000
      affordable units, built $100MM in
      custom luxury homes, and $100MM in
      land subdivisions, all throughout
      the Northeast. Joe is a private
      pilot enthusiast and enjoys watching
      his children excel in sporting
      activities.`
  }
];
